export default {
  param: {
    create: '创建公众号菜单',
    wechatUrl: '公众号域名',
    appId: 'appId',
    appSecret: 'appSecret',
    menuJson: 'menu json'
  },
  sendrecord: {
    searchPlaceholder: '输入供应商编号/推送单号进行搜索',
    sendAction: '推送节点',
    docNo: '推送单号',
    docDate: '单据日期',
    templateName: '推送模板',
    supplierNo: '供应商编号',
    userName: '用户',
    loginName: '姓名',
    nickName: '微信昵称',
    sendTime: '推送时间',
    sendMsg: '推送日志',
    isSuccess: '成功否',
    read: '已读否',
    Y: '是',
    N: '否',
    startDate: '推送日期-起',
    endDate: '推送日期-止'
  },
  sendsetting: {
    searchPlaceholder: '输入模板名称节点名称进行搜索',
    sendAction: '推送节点',
    actionName: '推送节点',
    templateName: '推送模板名',
    sendTemplate: '模板ID',
    clickUrl: '跳转链接',
    useful: '是否应用',
    useful0: '是',
    useful1: '否',
    remarks: '备注',
    actionName1: '确认订单',
    actionName2: '新订单',
    actionName3: '订单变更',
    actionName4: '订单答交',
    actionName5: '订单结案',
    actionName6: '发货',
    actionName7: '取消发货',
    actionName8: '收货',
    actionName9: '验退',
    actionName10: '仓退',
    Y: '应用',
    N: '未应用'
  }
}
